import request from "./httpService";

const CREDIT_MEMO_ENDPOINT = '/credit-memos';

class CreditMemoService {
    
    static async createCreditMemo(creditMemoData) {
        return request({
            method: 'POST',
            url: CREDIT_MEMO_ENDPOINT,
            data: creditMemoData,
        });
    }

    static async getCreditMemosByInvoiceId(invoiceId) {
        return request({
            method: 'GET',
            url: `${CREDIT_MEMO_ENDPOINT}/invoice/${invoiceId}`,
        });
    }

    static async updateCreditMemoStatus(creditMemoId, status, authorizedBy) {
        return request({
            method: 'PATCH',
            url: `${CREDIT_MEMO_ENDPOINT}/${creditMemoId}/status`,
            data: { status, authorizedBy },
        });
    }

    static async applyCreditMemo(creditMemoId, invoiceIdToApplyTo, amountToApply) {
        return request({
            method: 'POST',
            url: `${CREDIT_MEMO_ENDPOINT}/${creditMemoId}/apply`,
            data: { invoiceIdToApplyTo, amountToApply },
        });
    }

    static async cancelCreditMemo(creditMemoId, reason, authorizedBy) {
        return request({
            method: 'POST',
            url: `${CREDIT_MEMO_ENDPOINT}/${creditMemoId}/cancel`,
            data: { reason, authorizedBy },
        });
    }

    static async getAvailableCreditMemosByCustomerId(customerId) {
        return request({
            method: 'GET',
            url: `${CREDIT_MEMO_ENDPOINT}/customer/${customerId}/available-credit`,
        });
    }

    static async getCreditMemosByCustomerId(customerId, offset, limit, filters, sortBy, signal) {
        return request({
            method: 'GET',
            url: `${CREDIT_MEMO_ENDPOINT}/customer/${customerId}/withlimit/${offset}/${limit}`,
            params: { filters, sortBy },
            signal,
        });
    }
}

export default CreditMemoService;
